import { render, staticRenderFns } from "./IntelligentPurchase.vue?vue&type=template&id=1770efa2&"
import script from "./IntelligentPurchase.vue?vue&type=script&lang=js&"
export * from "./IntelligentPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports